import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { RootState, useAppDispatch } from "../../../../redux/store";
import { retrievePageMenu } from "../../../../redux/slice/page-menu.slice";
import TwoColumnLayOut from "../../../../layouts/two-columns/two-column-layout";
import { retrieveAccordion } from "../../../../redux/slice/accordion-slice";
import { useDynamicScripts } from "../../../../hooks/useDynamicScript";
import LoadingComp from "../../../../components/re-usable/loading/loading";

const RAPSFellows = () => {
  const breadcrumbPath = "Membership%2FRAPS-Fellows%2FMeet-RAPS-Fellows";
  const path = `%2F${breadcrumbPath}`;

  const dispatch = useAppDispatch();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [htmlString, setHtmlString] = useState("Loading...");
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    dispatch(retrievePageMenu(path));
    dispatch(retrieveAccordion(`%2FMembership%2FRAPS-Fellows%2FMeet-RAPS-Fellows%2FAccordion-Items`));
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]) {
      if (RapsEuropeData[0].result[0] && RapsEuropeData[0].result[0].description) {
        setHtmlString(RapsEuropeData[0].result[0].description);
      }
    }
  }, [RapsEuropeData]);

  useEffect(() => {
    if (RapsEuropeData[0]?.result[0]?.javaScriptField) {
      setScriptHtmlString(RapsEuropeData[0]?.result[0]?.javaScriptField);
    }
  }, [RapsEuropeData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={breadcrumbPath} isBreadcrumbpath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.councilDescription }}></div>
      </TwoColumnLayOut>
    </>
  );
};

export default RAPSFellows